// extracted by mini-css-extract-plugin
export default {"label":"styles_label__LFMjp","checkbox_container":"styles_checkbox_container__EDpVz","checkbox":"styles_checkbox__F2-xZ","icon":"styles_icon__LM0ow"};